module.exports = __webpack_public_path__ + "static/index/img/baikal-906.91dd8ba5.jpg";